module.exports = __webpack_public_path__ + "static/customer-service-b5c9445a6d1b866e3612e339f7ad9250.svg";